import type { Product, GRPBenefit, Industry, Stat, ContactInfoItem, Testimonial, ProcessStep } from '../types';

export const NAV_LINKS: string[] = ['About', 'Products', 'Why GRP', 'Gallery', 'Contact'];

/* ═══ PRODUCT CATEGORIES ════════════════════════════════════ */
export const PRODUCT_CATEGORIES: string[] = [
  'All',
  'GRP Core',
  'Infrastructure',
  'Architecture',
  'Outdoor & Urban',
  'Flooring',
  'Aluminium & Glass',
];

/* ═══ FULL PRODUCT LIST (from catalogue) ════════════════════ */
export const ALL_PRODUCTS: Product[] = [
  /* ── GRP Core ── */
  {
    icon: '💧', tag: 'GRP Core',
    title: 'GRP Water Tanks',
    subtitle: 'Safe. Efficient. Built to Last.',
    desc: 'Engineered to store potable and non-potable water safely and efficiently in both residential and industrial environments. Built with high-grade fiberglass-reinforced plastics for long-term performance in extreme Gulf climates.',
    img: '../water-tank.webp',
  },
  {
    icon: '🔒', tag: 'GRP Core',
    title: 'GRP Cabinets & Enclosures',
    subtitle: 'Secure. Weatherproof. Custom-Built.',
    desc: 'Superior protection for sensitive equipment, electrical systems, and communication infrastructure. Designed for harsh outdoor and industrial environments where durability and reliability are critical.',
    img: '../cabinets-enclosures.webp',
  },
  {
    icon: '🔧', tag: 'GRP Core',
    title: 'GRP Cylinders',
    subtitle: 'Engineered for Strength & Lightness.',
    desc: 'Precision-molded GRP cylinders reinforced for strength, lightweight performance, and long-term durability. Ideal for industrial, architectural, and utility applications across the Gulf.',
    img: '../underground-cylinder.webp',
  },
  {
    icon: '🛵', tag: 'GRP Core',
    title: 'GRP Food Delivery Boxes',
    subtitle: 'Hygienic. Durable. Built for Delivery.',
    desc: 'Lightweight, thermally insulated, and weather-resistant delivery boxes ensuring meals are delivered safely, fresh, and at the right temperature. Designed for the evolving food delivery industry.',
    img: '../food-delivery-boxes.webp',
  },
  {
    icon: '🚽', tag: 'GRP Core',
    title: 'GRP Portable Toilets',
    subtitle: 'Hygienic. Mobile. Durable.',
    desc: 'Designed for construction sites, outdoor events, parks, and remote areas. Our GRP Portable Toilets offer clean, reliable sanitation in any environment with high-quality, weather-resistant materials.',
    img: '../portable-toilet.webp',
  },
  {
    icon: '🎨', tag: 'GRP Core',
    title: 'GRP Sculptures',
    subtitle: 'Crafting Art in Composite Form.',
    desc: 'Custom GRP sculptures — lightweight, weather-resistant, and highly durable for indoor & outdoor installations. From abstract designs to lifelike figures, we bring creative visions to life with precision.',
    img: '../sculpture.webp',
  },
  {
    icon: '🎨', tag: 'Infrastructure',
    title: 'GRP Shed',
    subtitle: 'GRP Fiberglass Shed and Roofing',
    desc: 'we provide high-quality GRP fibreglass shed and roofing supplier UAE Dubai solutions designed for durability, weather resistance, and long-term performance',
    img: '../shed.webp',
  },

  /* ── Infrastructure ── */
  {
    icon: '🏗️', tag: 'Infrastructure',
    title: 'GRP Gratings & Flooring Panels',
    subtitle: 'Strong. Safe. Slip-Resistant.',
    desc: 'Lightweight, corrosion-resistant, high-strength flooring solution for industrial and commercial needs. Built to perform in extreme environments, ensuring long-lasting durability and safety underfoot.',
    img: '../gratings-floorpanels.webp',
  },
  {
    icon: '🪜', tag: 'Infrastructure',
    title: 'GRP Handrails, Ladders & Platforms',
    subtitle: 'Safe. Lightweight. Long-Lasting.',
    desc: 'Reliable, corrosion-resistant access and safety systems for demanding industrial and outdoor environments. Manufactured to meet international safety standards with zero-maintenance operation.',
    img: '../handrails-platforms.webp',
  },
  {
    icon: '🔩', tag: 'Infrastructure',
    title: 'GRP Manholes, Covers & Kiosks',
    subtitle: 'Engineered for Strength. Built for Harsh Environments.',
    desc: 'Secure, durable access and housing solutions that outperform concrete and metal. Ideal for utilities, drainage, telecom, and monitoring applications with zero maintenance and easy installation.',
    img: '../manhole-split.webp',
  },
  {
    icon: '☀️', tag: 'Infrastructure',
    title: 'Solar Water Heaters',
    subtitle: 'Harness the Power of the Sun.',
    desc: 'Engineered for high performance and energy efficiency, perfect for residential, commercial, and industrial use. Built with corrosion-resistant tanks and advanced vacuum tube or flat plate collectors.',
    img: '../solar-water-heater.webp',
  },
  {
    icon: '🛡️', tag: 'Infrastructure',
    title: 'Epoxy Coating & GRP Lamination',
    subtitle: 'Seamless Protection. Superior Strength.',
    desc: 'High-performance solutions for waterproofing, chemical resistance, and structural reinforcement across industrial and commercial sectors. Delivering seamless protection with superior bonding strength.',
    img: '../floorings-epoxy.webp',
  },

  /* ── Architecture ── */
  {
    icon: '🏛️', tag: 'Architecture',
    title: 'GRP Cladding & Decorative Panels',
    subtitle: 'Stylish. Resilient. Maintenance-Free.',
    desc: 'Attractive, durable, low-maintenance cladding for building exteriors and interiors. Designed to resist weather, corrosion, and impact — ideal for both functional protection and aesthetic transformation.',
    img: '../cladding.webp',
  },
  /* ── Outdoor & Urban ── */
  {
    icon: '🌿', tag: 'Outdoor & Urban',
    title: 'GRP Planter Pots',
    subtitle: 'Stylish. Resilient. Eco-Friendly.',
    desc: 'Lightweight GRP planter pots promoting healthier root systems and better drainage. Available in various sizes and shapes for all gardening and landscaping needs across residential and commercial spaces.',
    img: '../pots.webp',
},
  {
  icon: '🪜', tag: 'Infrastructure',
  title: 'Ladders',
  subtitle: 'Safe. Lightweight. Long-Lasting.',
  desc: 'Reliable, corrosion-resistant access and safety systems for demanding industrial and outdoor environments. Manufactured to meet international safety standards with zero-maintenance operation.',
  img: '../ladders.webp',
},
  {
  icon: '🏛️', tag: 'Infrastructure',
  title: 'Seats',
  subtitle: 'Safe. Lightweight. Long-Lasting.',
  desc: 'Lightweight, corrosion-resistant, and built to perform in the toughest environments.',
  img: '../seats.webp',
},
{
    icon: '🌿', tag: 'Indoor',
    title: 'GRP AC-Trays',
    subtitle: 'A solid piece of AC tray fiber glass that resists flames',
    desc: 'Flame-Retardant GRP AC Trays UAE Dubai are essential components for modern HVAC systems, designed to safely collect and drain condensation water from air conditioning units.',
    img: '../ac-tray.webp',
},

];

/* ── Legacy alias for Hero slider (first 8) ── */
export const PRODUCTS = ALL_PRODUCTS.slice(0, 8);

/* ═══ WHY GRP ════════════════════════════════════════════════ */
export const WHY_GRP: GRPBenefit[] = [
  { icon: '🛡️', title: 'Unrivaled Durability', desc: 'GRP resists corrosion, rust, and decay, making it ideal for the toughest conditions across all environments.' },
  { icon: '⚡', title: 'Lightweight, Heavy-Duty', desc: 'Easy to transport and install without compromising structural integrity — unmatched strength-to-weight ratio.' },
  { icon: '☀️', title: 'Weather & UV Resistant', desc: 'Perfect for outdoor and coastal environments, maintaining colour and form across decades of exposure.' },
  { icon: '🔥', title: 'Fire Retardant', desc: 'Enhanced safety for electrical and high-temperature zones, meeting international fire safety standards.' },
  { icon: '♻️', title: 'Eco-Friendly', desc: 'Sustainable materials with low environmental impact and a long lifecycle that reduces replacement waste.' },
  { icon: '🔧', title: 'Zero Maintenance', desc: 'No rusting, warping, or rotting — keeping operational costs minimal throughout the product lifecycle.' },
];

export const INDUSTRIES: Industry[] = [
  { name: 'Oil & Gas', icon: '🛢️', desc: 'Corrosion-resistant solutions for offshore and onshore facilities' },
  { name: 'Marine & Coastal', icon: '⚓', desc: 'UV and saltwater resistant structures for maritime environments' },
  { name: 'Utilities', icon: '⚙️', desc: 'Infrastructure-grade components for water and power distribution' },
  { name: 'Wastewater', icon: '🌊', desc: 'Chemical-resistant tanks and gratings for treatment plants' },
  { name: 'Construction', icon: '🏗️', desc: 'Architectural panels and structural elements for modern builds' },
  { name: 'Telecom & Electrical', icon: '📡', desc: 'Weatherproof enclosures and cabinets for sensitive systems' },
];

export const STATS: Stat[] = [
  { value: '28+', label: 'Product Categories' },
];

export const CONTACT_INFO: ContactInfoItem[] = [
  { icon: '📍', label: 'Address', value: 'Gulf FiberTech Industries LLC, Yard No:3, Al Jurf-2, Industrial Area, Ajman, United Arab Emirates' },
  { icon: '📧', label: 'Email', value: 'info@gulffibertech.com' },
  { icon: '📞', label: 'Phone', value: '+971 54 300 2654 / +971 054 300 2651' },
  { icon: '🕐', label: 'Business Hours', value: 'Sun – Thu: 8AM – 6PM GST' },
];

export const TESTIMONIALS: Testimonial[] = [
  { quote: 'Gulf Fibertech delivered GRP based products for our facility on time and to exact specification. Outstanding quality and technical support throughout.', name: 'Manager', company: 'Easy Lease Motor Cycle Rentals', avatar: '' },
];

export const PROCESS_STEPS: ProcessStep[] = [
  { num: '01', title: 'Submit Your Enquiry', desc: 'Share your project requirements, dimensions, and specifications through our enquiry form or by contacting our team directly.' },
  { num: '02', title: 'Technical Consultation', desc: 'Our engineering team reviews your requirements and provides expert guidance on materials, design, and optimal GRP solutions.' },
  { num: '03', title: 'Quotation & Approval', desc: 'We provide a detailed, competitive quotation. Once approved, our team prepares technical drawings and production schedules.' },
  { num: '04', title: 'Manufacturing & Delivery', desc: 'Precision-manufactured to your specifications in our UAE facility, quality-checked, and delivered on schedule to your site.' },
];

export const TICKER_ITEMS: string[] = ['GRP Water Tanks','GRP Cabinets','Gratings & Flooring','Handrails & Platforms','Manholes & Kiosks','Cladding Panels','GRP Domes','GRP Sculptures','WPC Decking','Solar Heaters','Aluminium Pergolas','Glass Railings','Artificial Grass','UAE Manufactured'];
